// extracted by mini-css-extract-plugin
module.exports = {"reference":"Header_reference__9jAL6","url":"Header_url__1FQ9q","btn":"Header_btn__39wWH","device":"Header_device__3Ytwc"};